import { render, staticRenderFns } from "./CirurgiaListar.vue?vue&type=template&id=1a0c3f02&scoped=true"
import script from "./CirurgiaListar.vue?vue&type=script&lang=js"
export * from "./CirurgiaListar.vue?vue&type=script&lang=js"
import style0 from "./CirurgiaListar.vue?vue&type=style&index=0&id=1a0c3f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c3f02",
  null
  
)

export default component.exports